import { useEffect, useState } from "react";
import {
  faGitAlt,
  faJsSquare,
  faReact,
  faSass,
} from "@fortawesome/free-brands-svg-icons";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.scss";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { faNode } from "@fortawesome/free-brands-svg-icons/faNode";

const About = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    const i = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);

    return () => clearTimeout(i);
  }, []);

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["A", "b", "o", "u", "t", " ", "m", "e"]}
              idx={15}
            />
          </h1>
          <p className="p">
            I am a dedicated and ambitious full-stack developer with a
            specialization in JavaScript and extensive experience in
            React-Native. My career goal is to secure a position in a
            forward-thinking IT company where I can leverage my skills to work
            on innovative and diverse projects.
          </p>
          <p align="LEFT">
            With a natural curiosity and a passion for continuous learning, I am
            always seeking to improve my expertise and tackle new challenges. I
            am confident in my abilities and thrive in environments that push me
            to grow and excel.
          </p>
          <p>
            I am excited about the opportunity to bring my unique blend of
            skills and passions to a dynamic team and contribute to the creation
            of cutting-edge solutions.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faSass} color="#DD0031" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faDatabase} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faNode} color="#7cb367" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default About;
